module.exports = __webpack_public_path__ + "static/media/ReportIcon.dab73cb0.svg";